module.exports = __webpack_public_path__ + "static/media/playinexch.44a6b9e1.png";